export default __webpack_public_path__ + "static/media/location.f5c4e357.png";